export const DEFAULT_COUNTRY_CODE = "91";

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function isValidLocalMobile(localMobile, minLength = 6) {
  return digitsOnly(localMobile).length >= minLength;
}

export function hasStoredMobile(mobileNumber, countryCode) {
  const { local_mobile } = parseStoredMobile(mobileNumber, countryCode);
  return isValidLocalMobile(local_mobile);
}

/** Split stored user mobile for display */
export function parseStoredMobile(mobileNumber, countryCode) {
  const code = digitsOnly(countryCode || DEFAULT_COUNTRY_CODE);
  const full = digitsOnly(mobileNumber);

  if (!full || full === code) {
    return { country_code: code, local_mobile: "", full_mobile: "" };
  }

  if (full.startsWith(code) && full.length > code.length) {
    return { country_code: code, local_mobile: full.slice(code.length), full_mobile: full };
  }

  return { country_code: code, local_mobile: full, full_mobile: code + full };
}

/** Split react-phone-input-2 value into country code + local number */
export function splitPhoneInputValue(fullValue, dialCode) {
  const code = digitsOnly(dialCode || DEFAULT_COUNTRY_CODE);
  const full = digitsOnly(fullValue);

  if (!full || full === code) {
    return { country_code: code, local_mobile: "" };
  }

  if (full.startsWith(code) && full.length > code.length) {
    return { country_code: code, local_mobile: full.slice(code.length) };
  }

  return { country_code: code, local_mobile: full };
}

/** Value for react-phone-input-2 from stored profile fields */
export function phoneInputValue(localMobile, countryCode) {
  const code = digitsOnly(countryCode || DEFAULT_COUNTRY_CODE);
  const local = digitsOnly(localMobile);
  return local ? code + local : "";
}

/** E.164-style display from stored profile fields */
export function formatDisplayMobile(mobileNumber, countryCode) {
  const { local_mobile, full_mobile } = parseStoredMobile(mobileNumber, countryCode);
  if (!isValidLocalMobile(local_mobile)) return "";
  return full_mobile ? `+${full_mobile}` : "";
}

/** Build phone state from react-phone-input-2 onChange */
export function phoneInputState(value, country) {
  const { country_code, local_mobile } = splitPhoneInputValue(value, country?.dialCode);
  return { phone: value, country_code, local_mobile };
}
